export default __webpack_public_path__ + "static/media/tab.0236fadd.svg";